var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.001 32.5595C135.388 33.231 135.766 33.9091 136.133 34.5936C135.466 34.1573 135.021 33.411 135.001 32.5595Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.312 15.2998C122.477 16.393 123.607 17.523 124.7 18.688C124.277 19.4693 123.451 20 122.5 20C121.119 20 120 18.8807 120 17.5C120 16.5493 120.531 15.7225 121.312 15.2998Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.406 3.86692C106.091 4.23413 106.769 4.61167 107.441 4.9993C106.589 4.97943 105.843 4.53374 105.406 3.86692Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5595 4.9993C33.231 4.61166 33.9091 4.23413 34.5936 3.86692C34.1573 4.53374 33.411 4.97943 32.5595 4.9993Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2998 18.688C16.393 17.523 17.523 16.393 18.688 15.2998C19.4693 15.7225 20 16.5493 20 17.5C20 18.8807 18.8807 20 17.5 20C16.5493 20 15.7225 19.4693 15.2998 18.688Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86692 34.5936C4.23413 33.9091 4.61166 33.231 4.9993 32.5595C4.97943 33.411 4.53374 34.1573 3.86692 34.5936Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.133 105.406C135.766 106.091 135.388 106.769 135.001 107.441C135.021 106.589 135.466 105.843 136.133 105.406Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.7 121.312C124.277 120.531 123.451 120 122.5 120C121.119 120 120 121.119 120 122.5C120 123.451 120.531 124.277 121.312 124.7C122.477 123.607 123.607 122.477 124.7 121.312Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.441 135.001C106.589 135.021 105.843 135.466 105.406 136.133C106.091 135.766 106.769 135.388 107.441 135.001Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5936 136.133C34.1573 135.466 33.411 135.021 32.5595 135.001C33.231 135.388 33.9091 135.766 34.5936 136.133Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.688 124.7C19.4693 124.277 20 123.451 20 122.5C20 121.119 18.8807 120 17.5 120C16.5493 120 15.7225 120.531 15.2998 121.312C16.393 122.477 17.523 123.607 18.688 124.7Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9993 107.441C4.97943 106.589 4.53374 105.843 3.86692 105.406C4.23413 106.091 4.61167 106.769 4.9993 107.441Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 2.5C50 3.88071 48.8807 5 47.5 5C46.1193 5 45 3.88071 45 2.5C45 1.11929 46.1193 0 47.5 0C48.8807 0 50 1.11929 50 2.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 2.5C65 3.88071 63.8807 5 62.5 5C61.1193 5 60 3.88071 60 2.5C60 1.11929 61.1193 0 62.5 0C63.8807 0 65 1.11929 65 2.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 2.5C80 3.88071 78.8807 5 77.5 5C76.1193 5 75 3.88071 75 2.5C75 1.11929 76.1193 0 77.5 0C78.8807 0 80 1.11929 80 2.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 2.5C95 3.88071 93.8807 5 92.5 5C91.1193 5 90 3.88071 90 2.5C90 1.11929 91.1193 0 92.5 0C93.8807 0 95 1.11929 95 2.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 17.5C35 18.8807 33.8807 20 32.5 20C31.1193 20 30 18.8807 30 17.5C30 16.1193 31.1193 15 32.5 15C33.8807 15 35 16.1193 35 17.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 17.5C50 18.8807 48.8807 20 47.5 20C46.1193 20 45 18.8807 45 17.5C45 16.1193 46.1193 15 47.5 15C48.8807 15 50 16.1193 50 17.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 17.5C65 18.8807 63.8807 20 62.5 20C61.1193 20 60 18.8807 60 17.5C60 16.1193 61.1193 15 62.5 15C63.8807 15 65 16.1193 65 17.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 17.5C80 18.8807 78.8807 20 77.5 20C76.1193 20 75 18.8807 75 17.5C75 16.1193 76.1193 15 77.5 15C78.8807 15 80 16.1193 80 17.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 17.5C95 18.8807 93.8807 20 92.5 20C91.1193 20 90 18.8807 90 17.5C90 16.1193 91.1193 15 92.5 15C93.8807 15 95 16.1193 95 17.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 17.5C110 18.8807 108.881 20 107.5 20C106.119 20 105 18.8807 105 17.5C105 16.1193 106.119 15 107.5 15C108.881 15 110 16.1193 110 17.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 32.5C20 33.8807 18.8807 35 17.5 35C16.1193 35 15 33.8807 15 32.5C15 31.1193 16.1193 30 17.5 30C18.8807 30 20 31.1193 20 32.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 32.5C35 33.8807 33.8807 35 32.5 35C31.1193 35 30 33.8807 30 32.5C30 31.1193 31.1193 30 32.5 30C33.8807 30 35 31.1193 35 32.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 32.5C50 33.8807 48.8807 35 47.5 35C46.1193 35 45 33.8807 45 32.5C45 31.1193 46.1193 30 47.5 30C48.8807 30 50 31.1193 50 32.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 32.5C65 33.8807 63.8807 35 62.5 35C61.1193 35 60 33.8807 60 32.5C60 31.1193 61.1193 30 62.5 30C63.8807 30 65 31.1193 65 32.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 32.5C80 33.8807 78.8807 35 77.5 35C76.1193 35 75 33.8807 75 32.5C75 31.1193 76.1193 30 77.5 30C78.8807 30 80 31.1193 80 32.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 32.5C95 33.8807 93.8807 35 92.5 35C91.1193 35 90 33.8807 90 32.5C90 31.1193 91.1193 30 92.5 30C93.8807 30 95 31.1193 95 32.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 32.5C110 33.8807 108.881 35 107.5 35C106.119 35 105 33.8807 105 32.5C105 31.1193 106.119 30 107.5 30C108.881 30 110 31.1193 110 32.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 32.5C125 33.8807 123.881 35 122.5 35C121.119 35 120 33.8807 120 32.5C120 31.1193 121.119 30 122.5 30C123.881 30 125 31.1193 125 32.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 47.5C5 48.8807 3.88071 50 2.5 50C1.11929 50 0 48.8807 0 47.5C0 46.1193 1.11929 45 2.5 45C3.88071 45 5 46.1193 5 47.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 47.5C20 48.8807 18.8807 50 17.5 50C16.1193 50 15 48.8807 15 47.5C15 46.1193 16.1193 45 17.5 45C18.8807 45 20 46.1193 20 47.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 47.5C35 48.8807 33.8807 50 32.5 50C31.1193 50 30 48.8807 30 47.5C30 46.1193 31.1193 45 32.5 45C33.8807 45 35 46.1193 35 47.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 47.5C50 48.8807 48.8807 50 47.5 50C46.1193 50 45 48.8807 45 47.5C45 46.1193 46.1193 45 47.5 45C48.8807 45 50 46.1193 50 47.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 47.5C65 48.8807 63.8807 50 62.5 50C61.1193 50 60 48.8807 60 47.5C60 46.1193 61.1193 45 62.5 45C63.8807 45 65 46.1193 65 47.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 47.5C80 48.8807 78.8807 50 77.5 50C76.1193 50 75 48.8807 75 47.5C75 46.1193 76.1193 45 77.5 45C78.8807 45 80 46.1193 80 47.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 47.5C95 48.8807 93.8807 50 92.5 50C91.1193 50 90 48.8807 90 47.5C90 46.1193 91.1193 45 92.5 45C93.8807 45 95 46.1193 95 47.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 47.5C110 48.8807 108.881 50 107.5 50C106.119 50 105 48.8807 105 47.5C105 46.1193 106.119 45 107.5 45C108.881 45 110 46.1193 110 47.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 47.5C125 48.8807 123.881 50 122.5 50C121.119 50 120 48.8807 120 47.5C120 46.1193 121.119 45 122.5 45C123.881 45 125 46.1193 125 47.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 47.5C140 48.8807 138.881 50 137.5 50C136.119 50 135 48.8807 135 47.5C135 46.1193 136.119 45 137.5 45C138.881 45 140 46.1193 140 47.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 62.5C5 63.8807 3.88071 65 2.5 65C1.11929 65 0 63.8807 0 62.5C0 61.1193 1.11929 60 2.5 60C3.88071 60 5 61.1193 5 62.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 62.5C20 63.8807 18.8807 65 17.5 65C16.1193 65 15 63.8807 15 62.5C15 61.1193 16.1193 60 17.5 60C18.8807 60 20 61.1193 20 62.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 62.5C35 63.8807 33.8807 65 32.5 65C31.1193 65 30 63.8807 30 62.5C30 61.1193 31.1193 60 32.5 60C33.8807 60 35 61.1193 35 62.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 62.5C50 63.8807 48.8807 65 47.5 65C46.1193 65 45 63.8807 45 62.5C45 61.1193 46.1193 60 47.5 60C48.8807 60 50 61.1193 50 62.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 62.5C65 63.8807 63.8807 65 62.5 65C61.1193 65 60 63.8807 60 62.5C60 61.1193 61.1193 60 62.5 60C63.8807 60 65 61.1193 65 62.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 62.5C80 63.8807 78.8807 65 77.5 65C76.1193 65 75 63.8807 75 62.5C75 61.1193 76.1193 60 77.5 60C78.8807 60 80 61.1193 80 62.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 62.5C95 63.8807 93.8807 65 92.5 65C91.1193 65 90 63.8807 90 62.5C90 61.1193 91.1193 60 92.5 60C93.8807 60 95 61.1193 95 62.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 62.5C110 63.8807 108.881 65 107.5 65C106.119 65 105 63.8807 105 62.5C105 61.1193 106.119 60 107.5 60C108.881 60 110 61.1193 110 62.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 62.5C125 63.8807 123.881 65 122.5 65C121.119 65 120 63.8807 120 62.5C120 61.1193 121.119 60 122.5 60C123.881 60 125 61.1193 125 62.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 62.5C140 63.8807 138.881 65 137.5 65C136.119 65 135 63.8807 135 62.5C135 61.1193 136.119 60 137.5 60C138.881 60 140 61.1193 140 62.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 77.5C5 78.8807 3.88071 80 2.5 80C1.11929 80 0 78.8807 0 77.5C0 76.1193 1.11929 75 2.5 75C3.88071 75 5 76.1193 5 77.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 77.5C20 78.8807 18.8807 80 17.5 80C16.1193 80 15 78.8807 15 77.5C15 76.1193 16.1193 75 17.5 75C18.8807 75 20 76.1193 20 77.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 77.5C35 78.8807 33.8807 80 32.5 80C31.1193 80 30 78.8807 30 77.5C30 76.1193 31.1193 75 32.5 75C33.8807 75 35 76.1193 35 77.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 77.5C50 78.8807 48.8807 80 47.5 80C46.1193 80 45 78.8807 45 77.5C45 76.1193 46.1193 75 47.5 75C48.8807 75 50 76.1193 50 77.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 77.5C65 78.8807 63.8807 80 62.5 80C61.1193 80 60 78.8807 60 77.5C60 76.1193 61.1193 75 62.5 75C63.8807 75 65 76.1193 65 77.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 77.5C80 78.8807 78.8807 80 77.5 80C76.1193 80 75 78.8807 75 77.5C75 76.1193 76.1193 75 77.5 75C78.8807 75 80 76.1193 80 77.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 77.5C95 78.8807 93.8807 80 92.5 80C91.1193 80 90 78.8807 90 77.5C90 76.1193 91.1193 75 92.5 75C93.8807 75 95 76.1193 95 77.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 77.5C110 78.8807 108.881 80 107.5 80C106.119 80 105 78.8807 105 77.5C105 76.1193 106.119 75 107.5 75C108.881 75 110 76.1193 110 77.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 77.5C125 78.8807 123.881 80 122.5 80C121.119 80 120 78.8807 120 77.5C120 76.1193 121.119 75 122.5 75C123.881 75 125 76.1193 125 77.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 77.5C140 78.8807 138.881 80 137.5 80C136.119 80 135 78.8807 135 77.5C135 76.1193 136.119 75 137.5 75C138.881 75 140 76.1193 140 77.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 92.5C5 93.8807 3.88071 95 2.5 95C1.11929 95 0 93.8807 0 92.5C0 91.1193 1.11929 90 2.5 90C3.88071 90 5 91.1193 5 92.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 92.5C20 93.8807 18.8807 95 17.5 95C16.1193 95 15 93.8807 15 92.5C15 91.1193 16.1193 90 17.5 90C18.8807 90 20 91.1193 20 92.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 92.5C35 93.8807 33.8807 95 32.5 95C31.1193 95 30 93.8807 30 92.5C30 91.1193 31.1193 90 32.5 90C33.8807 90 35 91.1193 35 92.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 92.5C50 93.8807 48.8807 95 47.5 95C46.1193 95 45 93.8807 45 92.5C45 91.1193 46.1193 90 47.5 90C48.8807 90 50 91.1193 50 92.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 92.5C65 93.8807 63.8807 95 62.5 95C61.1193 95 60 93.8807 60 92.5C60 91.1193 61.1193 90 62.5 90C63.8807 90 65 91.1193 65 92.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 92.5C80 93.8807 78.8807 95 77.5 95C76.1193 95 75 93.8807 75 92.5C75 91.1193 76.1193 90 77.5 90C78.8807 90 80 91.1193 80 92.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 92.5C95 93.8807 93.8807 95 92.5 95C91.1193 95 90 93.8807 90 92.5C90 91.1193 91.1193 90 92.5 90C93.8807 90 95 91.1193 95 92.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 92.5C110 93.8807 108.881 95 107.5 95C106.119 95 105 93.8807 105 92.5C105 91.1193 106.119 90 107.5 90C108.881 90 110 91.1193 110 92.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 92.5C125 93.8807 123.881 95 122.5 95C121.119 95 120 93.8807 120 92.5C120 91.1193 121.119 90 122.5 90C123.881 90 125 91.1193 125 92.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 92.5C140 93.8807 138.881 95 137.5 95C136.119 95 135 93.8807 135 92.5C135 91.1193 136.119 90 137.5 90C138.881 90 140 91.1193 140 92.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 107.5C20 108.881 18.8807 110 17.5 110C16.1193 110 15 108.881 15 107.5C15 106.119 16.1193 105 17.5 105C18.8807 105 20 106.119 20 107.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 107.5C35 108.881 33.8807 110 32.5 110C31.1193 110 30 108.881 30 107.5C30 106.119 31.1193 105 32.5 105C33.8807 105 35 106.119 35 107.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 107.5C50 108.881 48.8807 110 47.5 110C46.1193 110 45 108.881 45 107.5C45 106.119 46.1193 105 47.5 105C48.8807 105 50 106.119 50 107.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 107.5C65 108.881 63.8807 110 62.5 110C61.1193 110 60 108.881 60 107.5C60 106.119 61.1193 105 62.5 105C63.8807 105 65 106.119 65 107.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 107.5C80 108.881 78.8807 110 77.5 110C76.1193 110 75 108.881 75 107.5C75 106.119 76.1193 105 77.5 105C78.8807 105 80 106.119 80 107.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 107.5C95 108.881 93.8807 110 92.5 110C91.1193 110 90 108.881 90 107.5C90 106.119 91.1193 105 92.5 105C93.8807 105 95 106.119 95 107.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 107.5C110 108.881 108.881 110 107.5 110C106.119 110 105 108.881 105 107.5C105 106.119 106.119 105 107.5 105C108.881 105 110 106.119 110 107.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 107.5C125 108.881 123.881 110 122.5 110C121.119 110 120 108.881 120 107.5C120 106.119 121.119 105 122.5 105C123.881 105 125 106.119 125 107.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 122.5C35 123.881 33.8807 125 32.5 125C31.1193 125 30 123.881 30 122.5C30 121.119 31.1193 120 32.5 120C33.8807 120 35 121.119 35 122.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 122.5C50 123.881 48.8807 125 47.5 125C46.1193 125 45 123.881 45 122.5C45 121.119 46.1193 120 47.5 120C48.8807 120 50 121.119 50 122.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 122.5C65 123.881 63.8807 125 62.5 125C61.1193 125 60 123.881 60 122.5C60 121.119 61.1193 120 62.5 120C63.8807 120 65 121.119 65 122.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 122.5C80 123.881 78.8807 125 77.5 125C76.1193 125 75 123.881 75 122.5C75 121.119 76.1193 120 77.5 120C78.8807 120 80 121.119 80 122.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 122.5C95 123.881 93.8807 125 92.5 125C91.1193 125 90 123.881 90 122.5C90 121.119 91.1193 120 92.5 120C93.8807 120 95 121.119 95 122.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 122.5C110 123.881 108.881 125 107.5 125C106.119 125 105 123.881 105 122.5C105 121.119 106.119 120 107.5 120C108.881 120 110 121.119 110 122.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 137.5C50 138.881 48.8807 140 47.5 140C46.1193 140 45 138.881 45 137.5C45 136.119 46.1193 135 47.5 135C48.8807 135 50 136.119 50 137.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 137.5C65 138.881 63.8807 140 62.5 140C61.1193 140 60 138.881 60 137.5C60 136.119 61.1193 135 62.5 135C63.8807 135 65 136.119 65 137.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 137.5C80 138.881 78.8807 140 77.5 140C76.1193 140 75 138.881 75 137.5C75 136.119 76.1193 135 77.5 135C78.8807 135 80 136.119 80 137.5Z",
    fill: "#F6AA1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 137.5C95 138.881 93.8807 140 92.5 140C91.1193 140 90 138.881 90 137.5C90 136.119 91.1193 135 92.5 135C93.8807 135 95 136.119 95 137.5Z",
    fill: "#F6AA1C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.0bacdc391f15c101db2246d5fd72a8e7.svg";
export { ForwardRef as ReactComponent };